import gql from 'graphql-tag';

export const FEATURE_FLAGS = gql`
  query config_featureFlags {
    config_featureFlags
  }
`;
